import React from "react";
import PropTypes from "prop-types";
import Card from "@cx/ui/Card";
import PageHeader from "react-bootstrap/lib/PageHeader";
import Panel from "react-bootstrap/lib/Panel";
import ButtonToolbar from "react-bootstrap/lib/ButtonToolbar";
import Button from "@cx/ui/Button";
import config from "../config";

const PQ_URL = `${config.PQ_URL}`;

const Legal = ({ loading, payoffQuoteData }) => {
  return (
    <div>
      <Panel>
        <PageHeader>Payoff Quotes</PageHeader>
        <Card
          htmlId="CardDefault"
          header="Welcome to American Honda Finance Corporation (AHFC) Payoff Quote Portal"
        >
          <div>
            <p>
              <br />
              This page is exclusive for dealer payoff quotes via AHFC. Improper
              use of this site constitutes fraudulent behavior.
            </p>
          </div>
        </Card>
        <ButtonToolbar>
          <Button htmlId="login-button" href={PQ_URL} buttonStyle="primary">
            Login via Dealertrack
          </Button>
          <Button htmlId="sign-up-button" href="https://us.dealertrack.com/">
            Sign Up
          </Button>
        </ButtonToolbar>
        <p className="small margin-top-15-button">
          Sign ups for Dealertrack will entail a review of eligibility,
          registration has a 2-5 day standard turn around timeframe.
        </p>
      </Panel>
    </div>
  );
};

Legal.propTypes = {
  loading: PropTypes.bool,
  payoffQuoteData: PropTypes.object
};

export default Legal;
